export const SUBSCRIPTION_STORE_ENDPOINT = '/g/subscription-store/v2/subscriptions';
